var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.84006 2.40031L3.36673 8.19364C3.16006 8.41364 2.96006 8.84697 2.92006 9.14697L2.6734 11.307C2.58673 12.087 3.14673 12.6203 3.92006 12.487L6.06673 12.1203C6.36673 12.067 6.78673 11.847 6.9934 11.6203L12.4667 5.82697C13.4134 4.82697 13.8401 3.68697 12.3667 2.29364C10.9001 0.913641 9.78673 1.40031 8.84006 2.40031Z",
    stroke: "#494A4B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92676 3.3667C8.21342 5.2067 9.70676 6.61337 11.5601 6.80003",
    stroke: "#494A4B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.6665H14",
    stroke: "#494A4B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit-2.906f790122fc9dc3d382148a40692e85.svg";
export { ForwardRef as ReactComponent };